import { FC, useEffect, useRef, useState } from 'react'
import s from './Discount.module.scss'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { useDispatchIframePostMessage } from '@hooks'
import { Cross, Trash } from '@components/icons'
import { useUI } from '@components/ui/context'
import emailjs from 'emailjs-com'

const Discount: FC = () => {
  const DiscountRef = useRef() as React.MutableRefObject<HTMLDivElement>
  const contentRef = useRef() as React.MutableRefObject<HTMLDivElement>
  const [dispatch] = useDispatchIframePostMessage()
  const { closeDiscount } = useUI()
  const { openDiscount } = useUI()
  const { openChecklistSuccess } = useUI()
  const { closeChecklistSuccess } = useUI()

  const onKeyDownDiscount = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.code === 'Escape') {
      closeDiscount()
      closeChecklistSuccess()
    }
  }

  useEffect(() => {
    if (DiscountRef.current) {
      DiscountRef.current.focus()
    }

    const contentElement = contentRef.current

    if (contentElement) {
      disableBodyScroll(contentElement, { reserveScrollBarGap: true })
    }

    dispatch({
      event: 'setDiscountOpen',
      payload: true,
    })

    return () => {
      clearAllBodyScrollLocks()

      dispatch({
        event: 'setDiscountOpen',
        payload: false,
      })
    }
  }, [])

  const checklistText = 'No items in your list.'

  const itemlist = localStorage.getItem('checklistDiscount')
  var emaillist = ''
  if (itemlist) {
    var itemarray = itemlist.split('~')
    var checkitemarray = []
    for (var i = 0; i < itemarray.length; i++) {
      if (itemarray[i].length > 2) {
        emaillist += itemarray[i] + ' \n'
        checkitemarray.push(itemarray[i])
      }
    }
  }

  const removeFromDiscount = async (
    event: React.MouseEvent<HTMLElement>,
    productName: string
  ) => {
    event.preventDefault()
    var newitemlist = String(localStorage.getItem('checklistDiscount'))
    newitemlist = newitemlist?.replace(productName, '')
    newitemlist = newitemlist?.replace(/~+/g, '~')
    localStorage.setItem('checklistDiscount', newitemlist)
    closeDiscount()
    openDiscount()
    try {
    } catch (error) {
      throw error
    }
  }

  const sendDiscountEmail = async (
    event: React.SyntheticEvent<HTMLFormElement>
  ) => {
    event.preventDefault()
    emailjs
      .sendForm(
        'service_stbrxto', // service ID
        'template_butbqpd', // template ID for Amount Off
        event.currentTarget, //templateParams
        'TLmbzSmXJ0cTx_TA0' // public key
      )
      .then(
        (result) => {
          localStorage.removeItem('checklistDiscount')
          closeDiscount()
          openChecklistSuccess()
          console.log('Email Sent')
        },
        (error) => {
          console.log(error.text)
        }
      )
  }

  return (
    <div
      className={s.root}
      ref={DiscountRef}
      onKeyDown={onKeyDownDiscount}
      tabIndex={1}
    >
      <div>
        <div className={s.backdrop} onClick={closeDiscount} />
        <section className={s['sidebar-wrapper']}>
          <div className={s.sidebar}>
            <header className={s.header}>
              <h2 className={s.title}>REQUEST PRICING DISCOUNT</h2>
              <button onClick={closeDiscount} className={s.close}>
                <Cross />
              </button>
            </header>
            <div className={s.wrapper}>
              {itemlist ? (
                checkitemarray && checkitemarray.length ? (
                  <>
                    <ul className={s['cartitems']}>
                      {checkitemarray.map(function (itemname, index) {
                        return (
                          <li key={index}>
                            <span>{itemname}</span>
                            <button
                              className={s.remove}
                              onClick={(event) =>
                                removeFromDiscount(event, itemname)
                              }
                            >
                              <Trash width={20} height={20} />
                            </button>
                          </li>
                        )
                      })}
                    </ul>
                    <p>A price quote is coming your way soon. Please fill out this form and we'll send you the item(s) you've selected with the discounted price(s).</p>
                    <form
                      className={s.contactform}
                      onSubmit={sendDiscountEmail}
                    >
                      <label htmlFor="from_name">Full Name (Required)</label>
                      <input
                        className={s.input}
                        placeholder="Full Name *"
                        type="name"
                        id="from_name"
                        name="from_name"
                        required
                      />
                      <label htmlFor="from_email">Email (Required)</label>
                      <input
                        className={s.input}
                        placeholder="Email *"
                        type="email"
                        id="from_email"
                        name="from_email"
                        required
                      />
                      <label htmlFor="customer_state">State (Required)</label>
                      <select
                        className={s.input}
                        id="customer_state"
                        name="customer_state"
                        required
                      >
                        <option value="">State *</option>
                        <optgroup>
                          <option>Alabama</option>
                          <option>Alaska</option>
                          <option>Arizona</option>
                          <option>Arkansas</option>
                          <option>California</option>
                          <option>Colorado</option>
                          <option>Connecticut</option>
                          <option>Delaware</option>
                          <option>District Of Columbia</option>
                          <option>Florida</option>
                          <option>Georgia</option>
                          <option>Hawaii</option>
                          <option>Idaho</option>
                          <option>Illinois</option>
                          <option>Indiana</option>
                          <option>Iowa</option>
                          <option>Kansas</option>
                          <option>Kentucky</option>
                          <option>Louisiana</option>
                          <option>Maine</option>
                          <option>Maryland</option>
                          <option>Massachusetts</option>
                          <option>Michigan</option>
                          <option>Minnesota</option>
                          <option>Mississippi</option>
                          <option>Missouri</option>
                          <option>Montana</option>
                          <option>Nebraska</option>
                          <option>Nevada</option>
                          <option>New Hampshire</option>
                          <option>New Jersey</option>
                          <option>New Mexico</option>
                          <option>New York</option>
                          <option>North Carolina</option>
                          <option>North Dakota</option>
                          <option>Ohio</option>
                          <option>Oklahoma</option>
                          <option>Oregon</option>
                          <option>Pennsylvania</option>
                          <option>Rhode Island</option>
                          <option>South Carolina</option>
                          <option>South Dakota</option>
                          <option>Tennessee</option>
                          <option>Texas</option>
                          <option>Utah</option>
                          <option>Vermont</option>
                          <option>Virginia</option>
                          <option>Washington</option>
                          <option>West Virginia</option>
                          <option>Wisconsin</option>
                          <option>Wyoming</option>
                        </optgroup>
                      </select>
                      <label htmlFor="shipping_service">
                        Shipping Service
                      </label>
                      <select
                        className={s.input}
                        id="shipping_service"
                        name="shipping_service"
                        required
                      >
                        <option value="">Shipping Service *</option>
                        <optgroup>
                          <option>1-Day</option>
                          <option>2-Day</option>
                          <option>Ground (3-5 Days)</option>
                          <option>Mesa, Phoenix or Surprise, AZ Pick-up</option>
                        </optgroup>
                      </select>
                      <label htmlFor="referrer">
                        How did you hear about us?
                      </label>
                      <select className={s.input} id="referrer" name="referrer">
                        <option value="No Response">
                          How did you hear about us?
                        </option>
                        <optgroup>
                          <option>Google</option>
                          <option>Shasta Pools</option>
                          <option>Facebook</option>
                          <option>Friends and Family</option>
                          <option>Email</option>
                          <option>Home and Garden Show</option>
                        </optgroup>
                      </select>
                      <input
                        type="hidden"
                        name="product_list"
                        value={emaillist}
                      />
                      <input
                        className={s.checkout}
                        type="submit"
                        value="Send Price Request"
                      />
                    </form>
                    <button onClick={closeDiscount} className={s.addmore}>
                      Add More Items
                    </button>
                  </>
                ) : (
                  <>
                    <div className={s.noitems}>{checklistText}</div>
                  </>
                )
              ) : (
                <>
                  <div className={s.noitems}>{checklistText}</div>
                </>
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Discount
